import type { ColProps, FormProps, RowProps } from 'ant-design-vue'
import type { PropType } from 'vue'
import type { ISchema } from './types'

export const BdFormProps: any = {
  /**
   * 表单布局
   */
  layout: {
    type: String as PropType<'horizontal' | 'vertical'>,
    default: 'vertical'
  },
  col: {
    type: Object as PropType<ColProps>,
    default: () => ({
      span: 24
    })
  },
  row: {
    type: Object as PropType<RowProps>,
    default: () => ({ gutter: 16 })
  },
  /**
   * 提交失败自动滚动到第一个错误字段
   */
  scrollToFirstError: {
    type: Boolean as PropType<boolean>,
    default: true
  },
  /**
   * 生成规则
   */
  schema: {
    type: Array as PropType<ISchema>,
    default: () => []
  },
  attrs: {
    type: Object as PropType<FormProps>,
    default: () => ({})
  },
  model: {
    type: Object as PropType<Record<string, any>>,
    default: () => ({})
  },
  watch: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  /**
   * select是否使用form container
   */
  useContainer: {
    type: Boolean as PropType<boolean>,
    default: false
  }
}
